import * as XLSX from "xlsx";

export const parseExcelFile = async (file) => {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array" });
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });
  const headers = rows.length > 0 ? Object.keys(rows[0]) : [];
  const rowsWithId = rows.map((r, i) => ({ ...r, __rowId: `${Date.now()}-${i}` }));
  return { rows: rowsWithId, headers };
};

export default parseExcelFile;